<template>
    <div class="bg_eef1fa book web_detail">
        <div class="main">
            <div class="turn-container">
                <!--<iframe
                    class="child"
                    frameborder="0"
                    :src="'https://view.officeapps.live.com/op/view.aspx?src=' + detail.annex"
                >
                </iframe>-->
                <embed :src="detail.annex"></div>
                            <iframe :src="detail.annex"></iframe>
<!--                <iframe :src="'/static/pdf/web/viewer.html?file='+detail.annex"></iframe>-->
            </div>

            <div class="content flex_start align_items_flex_start">
                <div class="audit_list_operate flex_start">
                    <!--                    <img src="@/assets/images/ic_share_2.png" />-->
                    <img src="@/assets/images/ic_head.png" @click="likeBtn(detail.id)" v-if="is_like == 0" />
                    <img src="@/assets/images/header_red.png" @click="likeBtn(detail.id)" v-else />
                    <img src="@/assets/images/ic_download.png" @click="downloadBtn(detail.id)" />
                </div>
                <img :src="detail.pic" />
                <div class="content_info">
                    <h2>{{detail.title}}</h2>
                    <h3>
                        作者：{{detail.writer}}<br/>
                        出版社：{{detail.source}}<br/>
                        出版时间：{{detail.create_time}}
                    </h3>
                    <p class="flex_start flex_wrap">
                        <span v-for="(item,index) in detail.flag">{{item}}</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    export default {
        components: {},

        data () {
            return {
                id: 0,
                url:'',
                currentPage:1,
                detail: [],
                imgList:[],
                is_like: 0,
                is_good:0,
            }
        },
        created() {
            this.id = this.$route.query.id;
            this.$http({
                url: 'index/article',
                method: 'post',
                headers: {"Content-Type": "multipart/form-data"},
                data:{type:'book',id:this.id,token: localStorage.getItem('user_token')}
            }).then(res => {
                if(res.data.code == 1) {
                    this.detail = res.data.data.detail;
                    this.is_like = res.data.data.is_like;
                    this.is_good = res.data.data.is_good;
                    this.detail.img.forEach((item,index)=>{
                        this.imgList.push({url:item})
                    });
                } else {
                    layer.msg(res.data.msg);
                }
            });
        },
        mounted() {
        },
        methods: {
            likeBtn: function (id) {
                let _this = this;

                if(!localStorage.getItem('user_id'))
                {
                    layer.msg('请先登录，正在为您跳转，请稍后。。。');
                    setTimeout(function () {
                        _this.$router.push({
                            path: '/my/login'
                        })
                    },1500);
                    return false;
                }
                _this.$http({
                    url: 'my/likeBtn',
                    method: 'post',
                    headers: {"Content-Type": "multipart/form-data"},
                    data:{id:id,token: localStorage.getItem('user_token')}
                }).then(res => {
                    if(res.data.code == 1)
                    {
                        _this.is_like = _this.is_like == 1 ? 0 : 1;
                    }
                    layer.msg(res.data.msg);
                });
            },
            downloadBtn: function (id) {
                let _this = this;

                if(!localStorage.getItem('user_id'))
                {
                    layer.msg('请先登录，正在为您跳转，请稍后。。。');
                    setTimeout(function () {
                        _this.$router.push({
                            path: '/my/login'
                        })
                    },1500);
                    return false;
                }
                _this.$http({
                    url: 'my/downloadBtn',
                    method: 'post',
                    headers: {"Content-Type": "multipart/form-data"},
                    data:{id:id,token: localStorage.getItem('user_token')}
                }).then(res => {
                    if(res.data.code == 1)
                    {
                        let a = $("<a href='" + _this.detail.annex + "' target='_blank' download></a>").get(0);
                        let e = document.createEvent('MouseEvents');
                        e.initEvent('click', true, true);
                        a.dispatchEvent(e);
                    }else {
                        layer.msg(res.data.msg);
                    }
                });
            }
        },
    }
</script>
<style scoped>
    .book{padding:45px 0 70px;}
    .turn-container{width:100%;position: relative;}
    .turn-banner {
        width: 100%;
        /*height: 945px;*/
    }
    .turn-content {
        width: 100%;
        display: flex;
        margin: 0px auto;
        overflow: hidden;
    }

    .slider-bar {
        width: 100%;
        height: 8px;
        border-radius: 5px;
        background-color: #ccc;
        margin-top: 15px;
        display: flex;
        overflow: hidden;
    }
    .slider {
        flex: 1;
        cursor: pointer;
    }
    .slider-current {
        background-color: #666;
        border-radius: 5px;
    }
    iframe{width:100%;height: 80vh;object-fit: contain;display: block;border:0;margin:0 auto;}

    .no_data{width:100%;padding:20px 2%;font-size:16px;line-height: 30px;color:#333;}

    .content{width:100%;margin-top:27px;padding: 10px;background: #fff;position: relative;}
    .content img{width: 129px;height: 155px;margin-right: 19px;object-fit: cover;display: block;}
    .content_info{width: 422px;display: block;}
    .content_info h2{width:100%;font-size:24px;line-height: 38px;color:#000;display: block;}
    .content_info h3{width:100%;font-size:14px;line-height: 20px;color:#000;font-weight: normal;margin:5px 0 25px;}
    .content_info h3 i{font-weight: bold;white-space: nowrap;display: inline-block;}

    .content_info p{width: 100%;}
    .content_info p span{width: auto;font-size:14px;line-height: 21px;padding:0 10px;color:#000;display: block;border:1px solid #000;border-radius: 16px;margin-right: 16px;margin-bottom: 3px;}


    .audit_list_operate{width:117px;height: 34px;position: absolute;top:10px;right:20px;background: #f5f5f5;z-index:2;}
    .audit_list_operate img{width:39px;height: 20px;object-fit: contain;display: block;margin:7px auto;}

    .left_prev,.left_next{width: 47px;height: 93px;text-align: center;background-size: 26px auto;background-position: center;background-repeat: no-repeat;background-color: #404337;margin-top:0;transform: translateY(-50%);position: absolute;top:50%;z-index:9;}
    .left_prev{left:0;background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAAAoZJREFUaEPlm1FSwjAQhjfvdNQbcARuAJ5AX8UH9QbUCwgniJcAjmG5AdzEGTqDzhTipFWmlLZD0k12bXnigbb5svvnT3aLgH/wkYtYnQxTqNvwIYhshi5sLvJ1jVzu+gDJEygxbT2wnMcDBTAUAt7PJriNEZaLWKfssDSb2gYsF/EHAAwA4LosuvCVrMOXm08babHSsFxuR2lUi5rNyFagVBQ+Bqd6NqTmBTzfTkGIt1IGpWZNYfV92QDXaTYc99DGiXYjw8w6/lyvxiBAVmh2A0JNbD23bEykwLXWA7ABgCgc9ya2k8kP2JH11E0QWYRdWg8rYB/WwwvYg/WwAXa1XTRZ1Lxo+BLrabJdZAVMYT2kKc0hjfMT4DSlqazHe4Sprcc/MLH1eAXmptkiPJqGOVmP8wjr6qI67O9KC26OTj0m3ou+Sss6zTYouNlCOY3wWZE89zTMSgUWvLWGOVuPkwjXpjFSwQ0rqo01zN160CNcAZwW3Hydemyjb6XhCuC1AjUR38nGtitgC2FyHSZw9lxmNoS20+rUoqVnLbWlA4wqWiMRCBWFD8HMJN18/NYqpfMD68zG4wS6S1vLLL13fVD7e/21JC3XutWJ3TKxTf/GKf334N/joX49QTeyrwoDYmNZaMBHcIJ+kUm00YHTFO9SiYe7ZTmJcCG9yzQNCtSIYhvqFDiNNjNNuwfOXmnQb+ewsCznwNkilkKzsCwvwJwsyyswB8vyD0x8yvIOTG1ZZMBUlkULTGBZpMCXWtbrOFiZHBDQy7RYDy9UTipfCMds2ZBH+OLKCVI3gxewB8tiBezDslgCu7QsvsB1ltWgu8EW+FgNPSTPZ8X+tgLnNI32V7wfeQO7TNbYiaMAAAAASUVORK5CYII=");}
    .left_next{right:0;background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAAAmhJREFUaEPlm91RwkAQx/cgM+pMmKET6AAsA2iCqwBowNgB+iC8agVCB5RgB+iE93MSo2ZCPo/bD2OeE+5+2d373/03KLC8gm04BqNe04/rqa8sf47sMesJ5gGDMksA71FPbt7ICBoO5BYYAIyBuQLY65l/aDgXktudAyez3uupPyYhaDiIPfD62Idrb5it42T8dwA46Kl/23A+6LdbA3/PLHgKl6BUFM3R2Wzjmoa9nvR26CQ1B7gYOBongV7kjmnMSs96EbiIywnwT7Q3J1NAJaam3QJ/afM9AAwy4HFNgwHNvXo7BY7Te3OKgKOazkKLkCznwDF0zi4sFXHW9MYBFixZKMCSJQsVWKJkoQNLq2ka4N+aZpcsEuDUxoRdskiBJaQ3PTCzZJEDc0sWGzCXZLECc9Q0PzCxZLED15asTvfFhRsqBrgyvR05J6KAazgncKnZLxMY0RgUCYwpWWKBK2s6sn8tzH7ZwOWS1U5gc+UNFMRO6DDjhLYQGMEMFJvSWN0MkcDBNlyAiftV5x1IY1bQgZ1tv0omcHHLpl0bj1IDv21by6RFE7Vcs6txtDhrUN3nVhwegvWxXyI9H0kTbu6qCcdew9R9KFZgLOkp67yzAWNKjyjgVM3mffcR16zNoaDu9xTkEaau2eyLIAWulB4DO1ercVHESYCppYe9hrnTOP0C0CPMIT1sEeaSHnJgbumhB0ZwKurqbNV9zmtYgvSQRfhuE44KDDfnp56qSJLocPBfPi6VJj2oKS1RelCAJUsPDrBg6aEG1kBw6iFfpXMPBLFJ7j24cBdtgaqes954/NW/4n0CjiulTA6/vQQAAAAASUVORK5CYII=");}

    @media screen and (max-width: 1920px) {
        .web_detail{width: 100%;padding:3.629vw 2% 5.645vw;margin:0 auto;}
        #flipbook{width: 100% !important;height: 76.77vw !important;max-height: 952px;}
        .left_prev,.left_next{width: 3.7903vw;height: 7.5vw;background-size:2.09677vw auto;}
    }
    @media screen and (max-width: 640px) {
        .content{margin-top:2.177vw;}
        .content img{display: none;}
        .audit_list_operate img{display: block;}
        .content_info{width: 100%;}
        .content_info h3{margin:1vw 0 2vw;}
        .content_info p span{border-radius: 5px;margin-right: 2vw;}
    }
</style>



// WEBPACK FOOTER //
// src/pages/book/detail.vue